import { useEffect, useMemo, useRef, useState } from 'react'
import { Search, CornerDownLeft } from 'lucide-react'

// Ctrl/Cmd+K page switcher - with ~25 dashboard pages, typing "bans" beats
// scanning the sidebar.
export default function CommandPalette({ items, onClose, onSelect }) {
  const [q, setQ] = useState('')
  const [index, setIndex] = useState(0)
  const inputRef = useRef(null)

  const results = useMemo(() => {
    const term = q.trim().toLowerCase()
    if (!term) return items
    return items
      .map((i) => {
        const hay = (i.label + ' ' + (i.desc || '')).toLowerCase()
        const score = i.label.toLowerCase().startsWith(term) ? 0 : i.label.toLowerCase().includes(term) ? 1 : hay.includes(term) ? 2 : 9
        return { i, score }
      })
      .filter((r) => r.score < 9)
      .sort((a, b) => a.score - b.score)
      .map((r) => r.i)
  }, [q, items])

  useEffect(() => { inputRef.current?.focus() }, [])
  useEffect(() => { setIndex(0) }, [q])

  const onKey = (e) => {
    if (e.key === 'Escape') onClose()
    else if (e.key === 'ArrowDown') { e.preventDefault(); setIndex((i) => Math.min(i + 1, results.length - 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setIndex((i) => Math.max(i - 1, 0)) }
    else if (e.key === 'Enter' && results[index]) onSelect(results[index].path)
  }

  return (
    <div className="fixed inset-0 z-[150] flex items-start justify-center p-4 pt-[12vh]" role="dialog" aria-modal="true" aria-label="Jump to page">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm dash-fade" onClick={onClose} />
      <div className="relative w-full max-w-lg dash-modal rounded-[24px] overflow-hidden dash-pop" onKeyDown={onKey}>
        <div className="flex items-center gap-3 px-4 h-14 border-b border-white/[0.06]">
          <Search className="w-4 h-4 text-[#5d6068]" />
          <input ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Jump to a page..." className="flex-1 bg-transparent outline-none text-[15px] text-white placeholder:text-[#5d6068]" />
          <kbd className="text-[10px] text-[#5d6068] px-1.5 py-0.5 rounded-md bg-white/[0.06]">Esc</kbd>
        </div>
        <ul className="max-h-[50vh] overflow-y-auto dash-scroll p-2">
          {results.length === 0 && <li className="px-3 py-8 text-center text-[13px] text-[#5d6068]">No pages match "{q}"</li>}
          {results.map((item, i) => {
            const Icon = item.icon
            return (
              <li key={item.path}>
                <button
                  onMouseEnter={() => setIndex(i)}
                  onClick={() => onSelect(item.path)}
                  className={'w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-colors ' + (i === index ? 'bg-white/[0.07]' : '')}
                >
                  <span className="w-8 h-8 rounded-lg bg-white/[0.05] flex items-center justify-center text-[#a6a8ae]"><Icon className="w-4 h-4" /></span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-[14px] text-white">{item.label}</span>
                    {item.desc && <span className="block text-[12px] text-[#8b8d94] truncate">{item.desc}</span>}
                  </span>
                  {i === index && <CornerDownLeft className="w-3.5 h-3.5 text-[#5d6068]" />}
                </button>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
